import { QueryStringParams } from '../constants/query-string-params';
import { updateQueryStringValue } from '../utils/string-helpers/search-query-string-helper';
import { ReadonlyURLSearchParams } from 'next/navigation';

// TODO: refactor and rename these. Such functions are not hooks, because they don't store any state and executed every time
// Adding a "use" at start of the name doesn't make a hook from a function
export function useQueryPagination(
  defaultPageSize: number,
  maxPageSize: number,
  searchParams: ReadonlyURLSearchParams,
) {
  const getResultsCount = (): number => {
    const paramCount = searchParams.get(QueryStringParams.Results);
    const resultsCount = paramCount && !Number.isNaN(paramCount) ? +paramCount : defaultPageSize;
    return resultsCount;
  };

  let searchQueryParams = {};
  for (const [key, value] of searchParams.entries()) {
    searchQueryParams[key] = value;
  }

  const setResultsCount = (count: number | string) =>
    updateQueryStringValue(searchQueryParams, QueryStringParams.Results, count.toString(), true);

  const getValidPageSize = () => {
    const pageSize = getResultsCount();
    let validPageSize = Math.ceil(pageSize / defaultPageSize) * defaultPageSize;
    if (pageSize < defaultPageSize && pageSize <= maxPageSize) {
      validPageSize = defaultPageSize;
    } else if (pageSize > maxPageSize) {
      validPageSize = maxPageSize;
    }

    return validPageSize;
  };

  const getCurrentPage = (): number => {
    const resultsCount = getResultsCount();
    return Math.floor(resultsCount / defaultPageSize);
  };

  const navigateToNextPage = (nextPageNumber: number) => {
    const resultsCount = nextPageNumber * defaultPageSize;
    setResultsCount(resultsCount);
  };

  const isNextPageAvailable = (totalCourses: number): boolean => {
    const currentPage = getCurrentPage();
    return totalCourses / defaultPageSize > currentPage;
  };

  return {
    getResultsCount,
    setResultsCount,
    getCurrentPage,
    getValidPageSize,
    navigateToNextPage,
    isNextPageAvailable,
  };
}
